import React, {FC, memo} from "react";
import {Currency, PaymentInterval, UpdateCourseAndBookingsInput} from "../../../../generated/graphql";
import {useCurrency} from "../../../../helpers/currencyHelper";
import {renderAmount} from "../../../../helpers/renderAmount";
import i18n from "../../../../services/i18n";
import BookingPriceOverview from "../../../../views/BookingPriceOverview/BookingPriceOverview";
import css from "./PaymentLists.less";
import {PreviewBookingType} from "../PreviewBooking";
import classNames from "classnames";

type TotalPriceInteractiveProps = {
    booking: PreviewBookingType;
    values: UpdateCourseAndBookingsInput;
    isChanged?: boolean;
};

const TotalPriceInteractive: FC<TotalPriceInteractiveProps> = ({booking, values, isChanged = false}) => {
    const currency = useCurrency();

    const renderCoursePrice = () => {
        return renderAmount({
            amount: booking.grossPrice ?? 0,
            currency: currency.short as Currency,
        });
    };

    let coursePrice = values?.coursePrice[0].grossPrice.toString() ?? "";

    if (values?.paymentInterval === PaymentInterval.PerLesson) {
        const courseLessonCount = values.lessons.length;

        coursePrice = (values.coursePrice[0].grossPrice * courseLessonCount).toString();
    }

    return (
        <>
            <div className={classNames(css.totalPrice, isChanged && css.totalPriceChanged)}>
                <div>{"Gesamtpreis"}</div>
                <div>
                    <>{renderCoursePrice()}</>
                </div>
            </div>
            <BookingPriceOverview
                grossPrice={booking.grossPrice}
                discount={booking.discount}
                discountName={booking.discountName}
                memberDiscount={booking.memberDiscount}
                creditedBalance={booking.creditedBalance}
                scheduledPayments={booking.scheduledPayments}
                variant="compact"
            />
        </>
    );
};

export default memo(TotalPriceInteractive);
